module.exports = __webpack_public_path__ + "static/img/3_1.cfe74df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/3_1.png
// module id = UZIX
// module chunks = 44